import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import nomeUsuario from './autenticacaoReducer';
import mensagem from './mensagemReducer';
import filtro from './filtroReducer';

const rootReducer = combineReducers({
    nomeUsuario,
    mensagem,
    filtro,
    router: routerReducer,
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/redux/reducers/index.js